import { QueryClient } from '@tanstack/react-query';

/**
 * The app's single QueryClient.
 *
 * Extracted out of main.tsx so non-React modules (the axios interceptor, the
 * idle-session watcher) can clear the cache on logout without importing the
 * entry point — `main.tsx → App → pages → services/* → apiClient → main.tsx`
 * is a cycle. React components should keep using `useQueryClient()`.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error: unknown) => {
        // Don't retry on 4xx errors (except 408 timeout)
        const status = (error as { response?: { status: number } })?.response?.status;
        if (status && status >= 400 && status < 500 && status !== 408) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
});
